import { BarChart2 } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Button } from '../ui/button';
import RunningWorkoutViz from './RunningWorkoutViz';
import { cn } from '../../lib/utils';

/**
 * Compact planned running workout card with optional detail affordance.
 */
export default function RunningExerciseCard({
  title,
  description,
  splits,
  className,
  onOpenDetail,
  vizHeightPx = 36,
}) {
  const { t } = useLanguage();
  const list = Array.isArray(splits) ? splits : [];
  return (
    <div className={cn('rounded-lg border border-border bg-card p-3 text-card-foreground shadow-sm', className)}>
      <div className="flex items-start gap-2">
        <div className="min-w-0 flex-1">
          {!!title && <p className="text-sm font-semibold text-foreground line-clamp-2">{title}</p>}
          {!!description && (
            <p className="mt-1 text-xs text-muted-foreground line-clamp-2">{description}</p>
          )}
          {!!list.length && (
            <div className="mt-3">
              <RunningWorkoutViz splits={list} heightPx={vizHeightPx} />
            </div>
          )}
        </div>
        {typeof onOpenDetail === 'function' && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-8 w-8 shrink-0 text-muted-foreground hover:text-foreground"
            onPointerDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              onOpenDetail();
            }}
            aria-label={t('runningExercise.openDetail')}
          >
            <BarChart2 className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
